module.exports = __webpack_public_path__ + "img/felicitaciones.42b12f41.jpg";